import helper from '@/libs/forms';

export default {
  schema: {
    fields: [
      helper.simpleInput('number', 'Estimated credit score', '',
        'estimatedCreditScore', false, 12),
    ],
  },
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/financial/resources/schemaCreditScore.js